export interface IGenericSelectOption {
	label: string;
	value: any;
	selected?: boolean;
	disabled?: boolean;
	id?: string;
}
